export default "__VITE_ASSET__CtBA3kbk__"